export default __webpack_public_path__ + "static/media/Joba Oluwajoba.1f8323cd.png";